if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.swiperOptions != undefined) { 
        this.initSwiper();
        const section = this.closest(".shopify-section");
        section.addEventListener("mouseleave", () => {
          this.swiper.autoplay.start();
        })
        return;
      }
      if (FoxTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }
    initSwiper(){
      const swiperOptions=JSON.parse(this.dataset.swiperOptions);
      this.swiper = new Swiper(this, {
        ...swiperOptions,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        on: {
          touchStart: () => {
            const wrapperEl = this.querySelector('.swiper-wrapper');
            if (wrapperEl) {
              wrapperEl.style.transitionTimingFunction = 'ease';
            }
          },
          touchEnd: () => {
            const wrapperEl = this.querySelector('.swiper-wrapper');
            if (wrapperEl) {
              wrapperEl.style.transitionTimingFunction = 'linear';
            }

          }
        },
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        freeModeMomentum: false,
        grabCursor: true,
      });
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
